var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"passage"},[_c('filtered-content',{staticClass:"container"},[_c('passage-filters')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }